// extracted by mini-css-extract-plugin
export default {"customers":"customer_customers__kOIgf","container":"customer_container__koHww","customer":"customer_customer__sNuaJ"};